export const PDF_LIST_FIELDS = [
  {
    name: 'Serial number',
  },
  {
    name: 'Date of calibration',
  },
  {
    name: 'Place of calibration',
  },
  {
    name: 'IMO',
  },
  {
    name: 'Vessel',
  },
  {
    name: 'Name',
  },
  {
    name: 'Action',
  },
];
